import React, { useState, useEffect } from "react";
import { withRouter } from "react-router";
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from "react-router-dom";
import Button from '@material-ui/core/Button';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import IconButton from '@material-ui/core/IconButton';
import HeadOrtail from "./Tasks/HeadOrTail";
import NumericalSequence from "./Tasks/NumericalSequence";
import CanadianQuestion from "./Tasks/CanadianQuestion";
import TimerWord from "./Tasks/TimerWord";
import MemoryQuestion from "./Tasks/MemoryQuestion";
import Definition from "./Tasks/Definition";
import {sendEmotionsPerformancesResults} from '../../../Utils'
import WheelOfFortune from "./Tasks/FortuneWheel/FortuneWheelTask";
import VerticalProgress from "./VerticalProgressBar";
import NextStep from "./NextStep";
import Carousel from "./EPTasksCarousel";
import { progressbarColors, maxPoints } from './Constants'

//Seconde page de l'expérience Intelligence EMotionnelle, c'est la page contenant tous les exercices.
//Les questions et les réponses de chaque série sont passés en paramètres de navigation (props.location)

//Le fonctionnement global est d'avoir une liste d'exercice à compléter (testOrder). On affiche le composant associé 
// à chaque exercice selon l'avancement de l'utilisateur dans la série d'exercices (experienceStep).

function EmotionsPerformancesTasks(props)  {
    

    const classes = useStyles();
    const history = useHistory();
    const [testOrder, setTestOrder]=useState() //Liste des étapes (exercices) de la série Gabriel: enelver le 1
    const [experienceStep, setExperienceStep]= useState('beginning'); //Etape actuelle  Gabriel 'beginning'
    const [experienceStepCount, setExperienceStepCount]= useState(0); //Compteur d'étape
    const [cheat, setCheat] = useState([]) //Coefficient de triche de l'utilisateur à chaque exercice
    const [tasksResults, setTaskResults] = useState([]) //réponses de l'utilisateur à chaque exercice
    const [timeToAnswer, setTimeToAnswer] = useState([]) //Temps de réponse à chaque tâche
    const [timeToAnswerTask, setTimeToAnswerTask] = useState(0) //Temps de réponse à la tâche actuelle

    // const [progressBarExampleValue, setprogressBarExampleValue]=useState(0)
    const [progressBarValue, setprogressBarValue]=useState(0)
    const progressBarValueAverage = [0,0,25,30,32,55,62,65,68,78,94].map(function(x) {return x / 100 * maxPoints}) //Valeurs pour la progress barre de la moyenne des utilisateur
    // const progressExampleValues = [5,16,24,43,66,78,98,100] //Valeurs d'exemples pour l'étape "beginning"

    const [startTimer, setStartTimer] = useState(false) // paramètre utilisé pour démarrer le timer dans l'exercice de vocabulaire
    const [memoryCheat, setMemoryCheat] = useState(0) //Paramètre utilisé pour détecter la triche dans l'exercice Memory
    

    useEffect(() => { 
        // var index = 0
        setStartTimer(false)
        if(props === undefined || props.location.user === undefined){
            history.push("/")
        }

        //On regarde si l'utilisateur est à sa première ou sa deuxième série à travers l'existence ou non d'une sanction en props.
        if(props.location.givenSanction === undefined){
            setTestOrder(['beginning', 'headOrTail','numericalSequences','fortuneWheel','CanadianQuestion','timerWord', 'memoryQuestion','definition','fin'])
        }else{
            var questions = ['beginning','numericalSequences','definition','CanadianQuestion','memoryQuestion','headOrTail','fortuneWheel','timerWord', 'fin']
            setTestOrder(questions)
            //on passe l'étape "beginning" (index 0) qui correspond à l'étape d'explication car l'utilisateur à déjà été mis au courant
            //des règles.
            setExperienceStep(questions[1])
            setExperienceStepCount(1)
        }

        //Incrémentation toutes les secondes de la valeur de progression pour la barre d'EXEMPLE.
        // setInterval(() => {
        //     if(index <8){
        //         setprogressBarExampleValue(progressExampleValues[index])
        //         index = index +1
        //     }else{
        //         index=0
        //     }          

        //   }, 1000);
    },[props, history ])


    //Fonction que l'on donne à tous les composants exercices en paramètres qu'ils pourront appeler pour renvoyer le résultat (et la triche)
    const addResult=(result, score, hasCheated)=>{
        if(experienceStep==='memoryQuestion'){//Cas particulier car triche gérée par le composant parent pour celui ci
            setCheat(cheat=>[...cheat, {[experienceStep] : memoryCheat}])
        }else{
            setCheat(cheat=>[...cheat, {[experienceStep] : hasCheated}])
        }
        setTaskResults(tasksResults=>[...tasksResults, {[experienceStep] : result}])

        setTimeToAnswer(timeToAnswer=>[...timeToAnswer, {[experienceStep] : (Date.now() -timeToAnswerTask)/1000}])
        movingForward()
        setprogressBarValue(progressBarValue+score)
        // Ce if n'est plus necessaire
        // if(progressBarValue+score > progressBarValueAverage[experienceStepCount + 1]){
        //     setprogressBarValue(progressBarValueAverage[experienceStepCount+1]-6)
        // }else{
        //     setprogressBarValue(progressBarValue+score)
        // }

    }

    const goTimer=()=>{
        setStartTimer(true)
    }


    //Fonction appelée soit par le bouton "question suivante" ou alors dans "addResult", càd quand l'utilisateur à valider les
    //résultats depuis le bouton du composant fils
    const movingForward= () => {
        setTimeToAnswerTask(Date.now())
        //On vérifie si la série et l'expérience sont terminées 
        if (experienceStepCount+1 === testOrder.length) {
            if (props.location.givenSanction !== undefined) { //On regarde si c'est la première ou la seconde série
                
                sendEmotionsPerformancesResults(props.location.user,props.location.actualSerie["Questions"], tasksResults, cheat,timeToAnswer, true, props.location.givenSanction )
                history.push({
                    pathname:"/experience/end", // Gabriel c'est ici que je dois changer
                    user : props.location.user,
                    sanctionGiven : props.location.givenSanction,
                    score: progressBarValue
                })
            } else {
                sendEmotionsPerformancesResults(props.location.user, props.location.actualSerie["Questions"], tasksResults, cheat,timeToAnswer, false, null )
                //Si la première série d'exercice est terminée, on passe à la page result avec en paramètre la seconde série d'exercice
                //qui sera elle-même transmise à intelligenceemotionelletask pour la seconde série.
                history.push({
                    pathname: "/experience/EmotionsPerformancesresults",
                    user : props.location.user,
                    actualSerie: props.location.nextSerie
                })
            }
        }
        setStartTimer(false)
        setExperienceStep(testOrder[experienceStepCount+1])
        setExperienceStepCount(experienceStepCount+1)
    }


    //Fonction permettant de revenir à la question précédente, appelée par le bouton précédent de ce composant.
    const movingBackward= () => {
        if(experienceStep === "memoryQuestion"){ //on détecte la triche pour la tâche MemoryQuestion
            setMemoryCheat(1)
        }  
        setStartTimer(false)
        setTimeToAnswerTask(Date.now())
        setExperienceStep(testOrder[experienceStepCount-1])
        setExperienceStepCount(experienceStepCount-1)
    }

    //Fonction qui renvoit l'exercice à afficher selon l'étape (avec la barre de progression)
    function getExperienceDiv(){
        var taskComponent = null
        if(experienceStep==="headOrTail"){              
            taskComponent = <HeadOrtail sendDataToParent={addResult}> </HeadOrtail>
        }else if(experienceStep==="numericalSequences"){        
            // taskComponent = <NumericalSequence  sendDataToParent={addResult}> </NumericalSequence> //Gabriel 
            taskComponent = <NumericalSequence series={props.location.actualSerie["Questions"]["numerical"]} answer={props.location.actualSerie["Answers"]["numerical"]} sendDataToParent={addResult}> </NumericalSequence>
        }else if(experienceStep==="CanadianQuestion"){       
            taskComponent =  <CanadianQuestion question={props.location.actualSerie["Questions"]["canadaCulture"]} answer={props.location.actualSerie["Answers"]["canadaCulture"]} sendDataToParent={addResult}></CanadianQuestion>
            // taskComponent =  <CanadianQuestion sendDataToParent={addResult}></CanadianQuestion> // Gabriel
        }else if(experienceStep==="timerWord"){        
            taskComponent = <TimerWord letter={props.location.actualSerie["Questions"]["letter"]} answer={props.location.actualSerie["Answers"]["letter"]} callbackStart={goTimer} startTimer={startTimer} sendDataToParent={addResult}></TimerWord>
            // taskComponent = <TimerWord callbackStart={goTimer} startTimer={startTimer} sendDataToParent={addResult}></TimerWord>
        }else if(experienceStep==="memoryQuestion"){        
            taskComponent = <MemoryQuestion  question = {props.location.actualSerie["Questions"]["memory"]} answer={props.location.actualSerie["Answers"]["memory"]} sendDataToParent={addResult}></MemoryQuestion>
            // taskComponent = <MemoryQuestion sendDataToParent={addResult}></MemoryQuestion>
        }else if(experienceStep==="definition"){
            taskComponent = <Definition  word={props.location.actualSerie["Questions"]["definition"]} answer={props.location.actualSerie["Answers"]["definition"]} sendDataToParent={addResult}></Definition>
            // taskComponent = <Definition sendDataToParent={addResult}></Definition>
        }else if(experienceStep==="fortuneWheel"){        
            taskComponent = <WheelOfFortune   sendDataToParent={addResult}></WheelOfFortune>
        }else if(experienceStep==='fin'){
          let averageScore = 0
          if (props.location.givenSanction !== undefined) {
            // A la reprise, il y a moins d'experience..
            averageScore = progressBarValueAverage[8]
          } else {
            averageScore = progressBarValueAverage[8]
          }
          const scores = {
            averageScore: averageScore,
            currentScore: progressBarValue,
          }
          taskComponent = <NextStep movingForward={movingForward} results={scores}></NextStep>
        }


        return <div className={classes.bodyContainer}>
          <div className={classes.task}>
            {taskComponent}
          </div>
          <div  className={classes.progressBarContainer}>
            <div className={classes.aboveProgressBar} style={{"left": "-5px"}}>
              <p>{maxPoints} points = 50$</p>
            </div>
            <div  className={classes.progressBar}>
              <VerticalProgress color={progressbarColors.user} score={progressBarValue} />
              <p>Score</p>
            </div>
            <div  className={classes.progressBar}>
              <VerticalProgress color={progressbarColors.average}  score={progressBarValueAverage[experienceStepCount]} />
              <p>Moyenne</p>
            </div>                
          </div>
        </div>
    }

return (
    <div className={classes.root}>   

        {/* Debut de l'expérience  */}
        { experienceStep === 'beginning' ?
        <div className={classes.taskContainer}>
          <div className={classes.centered}> 
            <Carousel>
              <p className={classes.text}>
              Donnez le meilleur de vous-même et poursuivez à la page suivante lorsque vous êtes prêt/prête à commencer.
              </p>
              <Button className={classes.buttonCarousel} variant="outlined" color="primary" onClick={movingForward}>Démarrer</Button>
            </Carousel>
          </div>

          <div  className={classes.progressBarContainer}>
            <div className={classes.aboveProgressBar}>
              <p>Exemple</p>
            </div>
            <div  className={classes.progressBar}>
              <VerticalProgress color={progressbarColors.user} score='175' />
                <p>Score</p>
              </div>
              <div className={classes.progressBar}>
              <VerticalProgress color={progressbarColors.average} score='210' />
                <p>Moyenne</p>
              </div>                
          </div>
        </div>
        :null }

        {/* Buttons précédent et suivant*/}
        { (experienceStep !== 'beginning') && (experienceStep !== 'ended') ?
        <div className={classes.allTaskContainer}>
          <div className={classes.taskContainer}>
            {getExperienceDiv()}
          </div>
          <div className={classes.footerTask}>
            <div className={classes.navigationButtonsContainer}>
              <div className={classes.backButton}>
                {(experienceStep !== testOrder[1]) && (experienceStep !== testOrder[8])? 
                <IconButton variant="contained" aria-label="arrow-back" onClick={movingBackward}>
                  <ArrowBackIcon />
                </IconButton>
                    :null}
              </div>
                <div className={classes.forwardButton}>
                { (experienceStep !== testOrder[7]) && (experienceStep !== testOrder[8])?
                  <IconButton variant="contained" aria-label="arrow-forward" onClick={movingForward}>
                    <ArrowForwardIcon />
                  </IconButton>
                  :null}
                </div>
            </div>
          </div>
        </div>
        :null}
    </div>

)}


const useStyles = makeStyles({
    root: {
        display: 'flex',
        flex:1,
        flexDirection:"column",
        marginTop:"4%",
        justifyContent:'center',
        fontSize : '1.5em',
        fontWeight: '200'
    },
    aboveProgressBar: {
      position: "absolute",
      top: "-60px",
      left: "55px",
    },
    text: {
        'margin': '10px 120px',
        'min-height': '20vh',
        'line-height': 1.3,
        'align-items': 'center',
        'justify-content': 'center',
        'display': 'flex'
    },
    button: {
        'margin-top': '15px',
        'margin-bottom': '15px',
    },
    buttonCarousel: {
        'margin-top': '15px',
        'margin-bottom': '60px',
    },
    centered:{
        alignItems:'center',
        display:'flex',
        flex:3,
        flexDirection:'column',
    },
    bodyContainer:{
        alignItems:'center',
        display:'grid',
        "grid-template-columns": "6fr 1fr",
        "grid-gap": "40px",
    },
    allTaskContainer:{
        display:'flex',
        flex:1,
        flexDirection:'column',
    },
    taskContainer:{
        alignItems:'center',
        display:'flex',
        flex:1,
        flexDirection:'row',
    },
    task:{
        display:'flex',
        flex:6,
        backgroundColor : '#FFF',
        padding:15,
        border : 'solid',
        borderColor : "#C0C0C0",
        borderRadius: 15
    },
    progressBar:{
        marginLeft:"3%",
        display:'flex',
        flex:1,
        justifyContent:'top',
        alignItems:'center',
        flexDirection:'column',
    },

    footerTask:{
        display:'flex',
        flexWrap:'wrap',
        justifyContent:'flex-end',
        flexDirection:'column',
    }
 ,
    navigationButtonsContainer:{
        flexDirection:'row',
        display:'flex',
    },
    forwardButton:{
        display:'flex',
        flex:1,
        alignSelf:'flex-end',
        justifyContent:'flex-end'
    },
    progressBarContainer:{
        display:'grid',
        position: 'relative',
        // flex:1,
        "grid-template-columns": "1fr 1fr",
        "grid-gap": "20px",
        // flexDirection:'row',
        // marginLeft: 20,
        // justifyContent:'space-around',
        alignItems:'center',
        'white-space':'nowrap',
        'font-size': '0.9em',
        'font-weight': '300',
    },
    finalText:{
        justifyContent:'center',
        alignItems:'center',
    }

})

 
export default withRouter(EmotionsPerformancesTasks);